import {
  REQUEST_PASSWORD_RESET,
  REQUEST_ACTIVATION_CODE,
  SIGNED_IN,
  SIGN_IN,
  SIGN_UP,
  fetchUser,
  passwordResetRequested,
  activationCodeRequested,
  signedIn,
  signedUp,
  error,
  unverifiedError,
  USER_RECEIVED,
} from '../store/modules/session'
import { combineEpics, ofType } from 'redux-observable'
import { filter, map, mergeMap, withLatestFrom } from 'rxjs'
import { logObservableError, logObservableErrorAndTriggerAction } from '../utilities/logs'
import { jsonStringify } from '../utilities/strings'
import { redirect } from '../store/modules/router'
import { includes } from 'ramda'

// signInEpic :: Epic -> Observable Action
export const signInEpic = (action$, state$, { fetchApi, logger }) =>
  action$.pipe(
    ofType(SIGN_IN),
    mergeMap(({ username, password }) => fetchApi('/v2/consumer/token', {
      method: 'POST',
      body: jsonStringify({
        username,
        password,
      }),
    })),
    map(response => signedIn(response.body || null)),
    logObservableErrorAndTriggerAction(
      'session :: signInEpic',
      e => e.status === 403 ? unverifiedError() : error(),
      logger,
    ),
  )

// loadUserOnSignedInEpic :: Epic -> Observable Action
export const loadUserOnSignedInEpic = (action$, state$, { fetchApi, logger }) =>
  action$.pipe(
    ofType(SIGNED_IN),
    map(fetchUser),
    logObservableError('session :: loadUserOnSignedInEpic', logger),
  )

// signUpEpic :: Epic -> Observable Action
export const signUpEpic = (action$, state$, { fetchApi, logger }) =>
  action$.pipe(
    ofType(SIGN_UP),
    withLatestFrom(state$),
    mergeMap(([ { nickname, email, password, newsletterSubscription, captcha }, state ]) =>
      fetchApi(`/v2/${state.router.locale}/users`, {
        method: 'POST',
        body: jsonStringify({
          nickname,
          email,
          password,
          newsletterSubscription,
          recaptcha: captcha,
        }),
      }),
    ),
    map(response => signedUp(response.body || null)),
    logObservableErrorAndTriggerAction('session :: signUpEpic', error, logger),
  )

// redirectToHomepageEpic :: Epic -> Observable action.REDIRECT
export const redirectToHomepageEpic = (action$, state$, { logger }) =>
  action$.pipe(
    ofType(USER_RECEIVED),
    withLatestFrom(state$),
    filter(([ _, state]) => includes(state.router.activeRoute.name, [
      'signIn', 'signInFr', 'signInAr',
      'signUp', 'signUpFr', 'signUpAr',
      'requestResetPassword', 'requestResetPasswordFr', 'requestResetPasswordAr',
    ])),
    map(([ _, state ]) => redirect('/' + state.router.locale)),
    logObservableError('router :: redirectToHomepageEpic', logger),
  )

// requestResetPasswordEpic :: Epic -> Observable Action
export const requestResetPasswordEpic = (action$, state$, { fetchApi, logger }) =>
  action$.pipe(
    ofType(REQUEST_PASSWORD_RESET),
    withLatestFrom(state$),
    mergeMap(([ { email }, state ]) => fetchApi(
      `/v2/${state.router.locale}/password-reset-token`,
      {
        method: 'POST',
        body: jsonStringify({ email }),
      },
    )),
    map(passwordResetRequested),
    logObservableErrorAndTriggerAction(
      'session :: requestResetPasswordEpic',
      error,
      logger,
    ),
  )

  // requestActivationCodeEpic :: Epic -> Observable Action
  export const requestActivationCodeEpic = (action$, state$, { fetchApi, logger }) =>
    action$.pipe(
      ofType(REQUEST_ACTIVATION_CODE),
      withLatestFrom(state$),
      mergeMap(([ { email }, state ]) => fetchApi(
        `/v2/${state.router.locale}/users/request-activation-code`,
        {
          method: 'POST',
          body: jsonStringify({ email }),
        },
      )),
      map(activationCodeRequested),
      logObservableErrorAndTriggerAction(
        'session :: requestActivationCodeEpic',
        error,
        logger,
      ),
    )

export default combineEpics(
  signInEpic,
  loadUserOnSignedInEpic,
  signUpEpic,
  requestResetPasswordEpic,
  redirectToHomepageEpic,
  requestActivationCodeEpic,
)
